import { useState, useEffect, useCallback } from 'react';
import { imageAPI } from '../services/api';

export interface ImageData {
  _id: string;
  filename: string;
  originalName: string;
  path: string;
  url: string;
  size: number;
  mimeType: string;
  width?: number;
  height?: number;
  category: 'carousel' | 'product_intro' | 'target_audience' | 'product_showcase' | 'news_header' | 'other';
  position: number;
  alt?: string;
  description?: string;
  isActive: boolean;
  tags?: string[];
  uploadedBy: {
    _id: string;
    username: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

interface UseImagesReturn {
  images: ImageData[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useImages = (category?: string): UseImagesReturn => {
  const [images, setImages] = useState<ImageData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchImages = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await imageAPI.getImagesByCategory(category || '');
      // response直接包含数据，因为axios拦截器已经处理了response.data
      setImages((response as any)?.images || []);
    } catch (err) {
      console.error('获取图片失败:', err);
      setError('获取图片失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  }, [category]);

  useEffect(() => {
    fetchImages();
  }, [fetchImages]);

  return {
    images,
    loading,
    error,
    refetch: fetchImages,
  };
}; 